'use strict';

var toString = require('./toString.js');

/**
 * Converts the given value to a string or returns null if the value is undefined or null.
 *
 * @param prop - The value to convert to a string or null.
 * @returns The string representation of the value, or null if the value is undefined or null.
 */ function toStringOrNull(prop) {
    return prop ? toString(prop) : null;
}

module.exports = toStringOrNull;
